<template>
  <!-- 批量设置坑位 -->
  <el-dialog
    title="批量设置坑位"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    class="dialog"
    center
  >
    <div style="max-height: 400px; overflow: auto" class="mt-20">
      <div
        v-for="(dItem, dIndex) in listData"
        :key="dIndex"
        class="d-flex a-center mb-15"
      >
        <div class="mr10" style="width: 200px; text-align: right">
          {{ dItem.name }}
        </div>
        <div style="width: 200px">
          <el-input
            placeholder="请输入"
            v-model="dItem.slot"
            @blur="
              () =>
                (dItem.slot =
                  dItem.slot == 0 ? 0 : tool.filterUnNumber(dItem.slot, true))
            "
          >
          </el-input>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onHandleSubmit"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import tool from "@/utils/tools/tool";
import { postCategoriesTagSlotSave } from "@/api/generalControl/category";
export default {
  name: "batchSetPit",
  components: {},
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      listData: [],
      logistic_business_id: "",
      tool,
    };
  },
  computed: {},
  methods: {
    onInitData(e, lId) {
      console.log(e, "e==");
      this.listData = [];
      this.listData = JSON.parse(JSON.stringify(e));
      this.logistic_business_id = lId;
      this.dialogVisible = true;
      this.submitLoading = false;
    },
    onHandleClose() {
      this.dialogVisible = false;
    },
    async onHandleSubmit() {
      this.submitLoading = true;
      let tmpTag = [];
      this.listData.map((mItem) => {
        tmpTag.push({
          tag_id: mItem.id,
          slot: mItem.slot,
        });
      });
      try {
        const res = await postCategoriesTagSlotSave({
          tag_list: tmpTag,
          logistic_business_id: this.logistic_business_id,
        });
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.submitLoading = false;
        this.dialogVisible = false;
        this.$emit("submit");
      } catch (error) {
        console.log(error, "postCategoriesTagSlotSave");
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
